module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Din Profil","braindates":"Brain dates","steps":"Steg","journeys":"Reiser","lifeskills":"Ferdigheter","wheelOfLifeTitle":"Ditt livshjul"},"en":{"title":"Your Profile","braindates":"Brain dates","steps":"Steps","journeys":"Journeys","lifeskills":"Lifeskills","wheelOfLifeTitle":"Your wheel of life"}}')
  delete Component.options._Ctor
}
